import { Component, OnInit, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { CommonServiceService } from '../../common-service.service';
import { environment } from 'src/environments/environment';
import * as moment from 'moment-timezone';
import { Router } from '@angular/router';
import { GlobalVariable } from '../../global-variable';
import { Store } from '@ngrx/store';
import { InitialState } from 'src/app/store/reducer';
@Component({
  selector: 'app-payment-search',
  templateUrl: './payment-search.component.html',
  styleUrls: ['../global-search.component.scss']
})
export class PaymentSearchComponent implements OnInit {

    modalRef: BsModalRef;
	paymentFilterForm: FormGroup;
	paymentArr: any;
	clientArr: any;
	keyword = 'name';
	fromAccount: any;
	toAccount: any;
	subLedger: any;
	dateFormat = 'YYYY-MM-DD';
  	isLocaleDateFormat: boolean = true;


	@ViewChild('airlineAC',{static:true}) airlineAC;
	@ViewChild('toaccountAC',{static:true}) toaccountAC;
	@ViewChild('subledgerAC',{static:true}) subledgerAC;
	@ViewChild('searchButton',{static:true}) searchButton : ElementRef;
	minDate = "2023-04-01"
    maxDate = moment().format('YYYY-MM-DD')  
	constructor(
		private modalService: BsModalService, 
		private formBuilder: FormBuilder, 
		public commonService: CommonServiceService, 
		private spinner: NgxSpinnerService,
		private router: Router,
		private store: Store<InitialState>) {
			this.store.select('sharedReducers').subscribe((items)=>{
				if(items.financeYear && items.financeYear.start_date && items.financeYear.end_date){
					this.minDate = items.financeYear.start_date
					this.maxDate = this.commonService.getFinancialSession(moment(items.financeYear.end_date)) < this.commonService.getFinancialSession(moment()) ? 
					            moment(items.financeYear.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
				} else {
					let current_financial_year =  JSON.parse(sessionStorage.getItem('current_financial_year'))
					if(!current_financial_year) {
						current_financial_year = JSON.parse(localStorage.getItem('current_financial_year'));
					}
					this.minDate = current_financial_year.start_date
					this.maxDate = this.commonService.getFinancialSession(moment(current_financial_year.end_date)) < this.commonService.getFinancialSession(moment()) ? 
					            moment(items.financeYear.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
				}
				
		})
	}

	ngOnInit() {

		// this.spinner.show();
		// setTimeout(() => {
		// 	this.spinner.hide();
		// }, 1000);

		this.paymentFilterForm = this.formBuilder.group({
			from_account: [''],
			from_account_name:[''],
			to_account: [''],
			to_account_name:[''],
			start_date: [this.minDate, this.checkDate('start_date')],
			end_date: [this.maxDate,this.checkDate('end_date')],
			payment_no: [''],
			from_amount: [''],
			to_amount: [''],
			narration: [''],
			sub_ledger_name: [''],
			sub_ledger:[''],
		})
		this.setFormData()
		this.getGlobalSettingsFormattedDate();
	}

	checkDate(formControlName){
		return (control: AbstractControl) => {
			let valid = true
			if(!moment(control.value, 'YYYY-MM-DD').isValid()) {
				valid = false
			} else {
				if(this){
					if (moment(control.value).isBefore(moment(this.minDate, 'YYYY-MM-DD')) || moment(control.value).isAfter(moment(this.maxDate, 'YYYY-MM-DD'))) {
						valid = false
					}
				}
			}
			return !valid ? {[formControlName]: {value: control.value}} : null;
		};
	}

	setFormData() {
		let queryParams = localStorage.getItem('activePaymentQueryParams')
		if (queryParams != null) {
			let parsedParams = JSON.parse(queryParams)
			console.log('Active Query Params', parsedParams)
			// this.paymentFilterForm.controls.from_account.setValue(parsedParams.from_account)
		    this.getFromAccount(parsedParams.from_account ? parsedParams.from_account : "",true)
		    this.getToAccount(parsedParams.to_account ? parsedParams.to_account : "",true)
		    this.getSubLedgerAccount(parsedParams.sub_ledger ? parsedParams.sub_ledger : "",true)
			
			this.paymentFilterForm.controls.start_date.setValue(moment(this.minDate).format('YYYY-MM-DD'))
			this.paymentFilterForm.controls.end_date.setValue(moment(this.maxDate).format('YYYY-MM-DD'))
			// this.paymentFilterForm.controls.to_account.setValue(parsedParams.to_account)
			this.paymentFilterForm.controls.payment_no.setValue(parsedParams.payment_no?parsedParams.payment_no:"")
			this.paymentFilterForm.controls.from_amount.setValue(parsedParams.from_amount?parsedParams.from_amount:"")
			this.paymentFilterForm.controls.to_amount.setValue(parsedParams.to_amount?parsedParams.to_amount:"")
			this.paymentFilterForm.controls.narration.setValue(parsedParams.narration?parsedParams.narration:"")
			// this.paymentFilterForm.controls.sub_ledger.setValue(parsedParams.sub_ledger)
		}
	  }

	getFromAccount(value,bindValue=false) {
		if(!value) {
			this.paymentFilterForm.controls['from_account'].setValue('')
			this.paymentFilterForm.controls['from_account_name'].setValue('')
		}
		if (value.length > 2) {
			this.commonService.getOkount(`v3account/ledgerautocomplete?name=${value.toUpperCase()}`).subscribe(res => {
				this.fromAccount = res
				debugger
				if(bindValue && this.fromAccount.length>0){
					this.paymentFilterForm.controls['from_account'].setValue(this.fromAccount[0].account_code)
					this.paymentFilterForm.controls['from_account_name'].setValue(this.fromAccount[0].name)
					
				}
			}, err => {
	
			})
		}
	}

	getToAccount(value,bindValue=false) {
		if(!value) {
			this.paymentFilterForm.controls['to_account'].setValue('')
			this.paymentFilterForm.controls['to_account_name'].setValue('')
		}
		if (value.length > 2) {
			this.commonService.getOkount(`v3account/ledgerautocomplete?name=${value.toUpperCase()}`).subscribe(res => {
				this.toAccount = res
				if(bindValue && this.toAccount.length>0){
					this.paymentFilterForm.controls['to_account'].setValue(this.toAccount[0].account_code)
					this.paymentFilterForm.controls['to_account_name'].setValue(this.toAccount[0].name)
					
				}
			}, err => {
	
			})
		}
	}

	getSubLedgerAccount(value,bindValue=false) {
		if(!value) {
			this.paymentFilterForm.controls['sub_ledger'].setValue('')
			this.paymentFilterForm.controls['sub_ledger_name'].setValue('')
		}
		if (value.length > 2) {
			this.commonService.getOkount(`v3account/ledgerautocomplete?name=${value.toUpperCase()}`).subscribe(res => {
				this.subLedger = res
				if(bindValue && this.subLedger.length>0){
					this.paymentFilterForm.controls['sub_ledger'].setValue(this.subLedger[0].account_code)
					this.paymentFilterForm.controls['sub_ledger_name'].setValue(this.subLedger[0].name)
					
				}
			}, err => {
	
			})
		}
	}
	
	reset() {
		GlobalVariable.openModalStatus = false;
		this.paymentFilterForm = this.formBuilder.group({
			from_account: [''],
			from_account_name:[''],
			to_account: [''],
			to_account_name:[''],
			start_date: [this.minDate],
			end_date: [this.maxDate],
			payment_no: [''],
			from_amount: [''],
			to_amount: [''],
			narration: [''],
			sub_ledger: [''],
			sub_ledger_name:['']
		})
		
		localStorage.removeItem('activePaymentQueryParams')

	  }

	openModal(template: TemplateRef<any>) {
		this.modalRef = this.modalService.show(
			template,
			Object.assign({}, { class: 'customModal' })
		);
	}

	search(values){
		GlobalVariable.openModalStatus = false;
		debugger
		if ((values.start_date == null || values.start_date == "" || values.start_date == "Invalid date" || values.start_date == "Invalid date")) {
			values.start_date = ""
		}else{
			values.start_date = moment(values.start_date).format('YYYY-MM-DD')
		}
		if((values.end_date == null || values.end_date == "" || values.end_date == "Invalid date" || values.end_date == "Invalid date")){
			values.end_date = ""
		}
		else{
			values.end_date = moment(values.end_date).format('YYYY-MM-DD')
		
		}

		let fromAccount= values.from_account
		if (values.from_account.account_code != undefined) {
			fromAccount= values.from_account.account_code
		} 
		let toAccount= values.to_account
		if (values.to_account.account_code != undefined) {
			toAccount= values.to_account.account_code
		} 
		let subLedger= values.sub_ledger
		if (values.sub_ledger.account_code != undefined) {
			subLedger= values.sub_ledger.account_code
		} 
		this.router.navigateByUrl(`/transactions/payment/view?from_account=${fromAccount}&to_account=${toAccount}&start_date=${values.start_date}&end_date=${values.end_date}&payment_no=${values.payment_no?values.payment_no:''}&from_amount=${values.from_amount?values.from_amount:''}&to_amount=${values.to_amount?values.to_amount:''}&narration=${values.narration}&sub_ledger=${subLedger}`)
		// this.reset()
	}


	ngAfterViewInit(){
		this.commonService.selectedSearchInput.subscribe(index=>{
			if (index == 1) {
				this.focusAirlineAc()
			}

			if(index == 2){
				this.focustoAccountAc()
			}

			if(index == 7){
				this.focusSubledgerAc()
			}

		})
	}


	selectAccount(value,formControlName){
		try {
			this.paymentFilterForm.controls[formControlName].setValue(value.account_code)
		} catch (error) {

		}
	}

	focusAirlineAc(): void {
		// e.stopPropagation();
		this.airlineAC.focus();
	}

	focustoAccountAc(): void {
		// e.stopPropagation();
		this.toaccountAC.focus();
	}

	focusSubledgerAc(){
		this.subledgerAC.focus();
	}

	clickSearchButton(){
		this.searchButton.nativeElement.click()
	}
	clearData(formControl){
		this.paymentFilterForm.controls[formControl].setValue("")
	}

	async getGlobalSettingsFormattedDate() {
      let globalSettingConfig = this.commonService.globalSettingConfig;
      if(!globalSettingConfig || globalSettingConfig.length == 0) {
        globalSettingConfig = await this.commonService.getGlobalSettings();
      }

      let dateConfig = await this.commonService.getDateFormat('date_format')
      this.dateFormat = dateConfig.dateFormat
      this.isLocaleDateFormat = dateConfig.isLocaleDateFormat;
    }
}
